export { SredLockPageLayout } from './SredLockPageLayout';
